<template>
  <div class="branches-list-view">
    <top-bar
      title="Sucursales"
      :show-add-button="$store.getters['profile/can']('branches.store')"
      add-button-label="Añadir Sucursal"
      @addItem="$router.push({name: 'branches-create'})"
    />
    <scrollable-container>
      <div class="padding-20">
        <ms-grid
          :data="items"
          :columns="columns"
          :options="options"
          :pager="pager"
        >

          <span
            slot="type"
            slot-scope="{row}"
          >
            <span class="type">
              {{ row.type }}
            </span>
          </span>
          <div
            class="branch-type-wrapper"
            slot="isMainBranch"
            slot-scope="{row}"
          >
            <span
              class="branch-type"
              :class="{main:row.isMainBranch}"
            >
              {{ row.isMainBranch | mainBranch }}
            </span>
          </div>
        </ms-grid>
      </div>
    </scrollable-container>
    <router-view/>
  </div>
</template>

<script>
import TopBar from '@/components/top-bar'
import DefaultActions from '@/helpers/default-actions'
import DefaultGuards from '@/guards/default.guards'
import ScrollableContainer from '@/components/scrollable-container'
import MsGrid from '@/modules/grid/ms-grid'
import StarRating from '@/components/star-rating.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BranchesList',
  components: {
    TopBar,
    ScrollableContainer,
    StarRating,
    MsGrid
  },
  filters: {
    mainBranch (value) {
      return value ? 'Matriz' : 'Sucursal'
    }
  },
  data () {
    return {
      columns: [
        {
          label: 'Tipo',
          property: 'type',
          align: 'center'
        },
        {
          label: 'Nombre',
          property: 'name',
          filter (value) {
            return value || '-'
          },
          link (row) {
            return {
              name: 'branches-view',
              params: { id: row.id }
            }
          }
        },
        {
          label: 'Municipio',
          property: 'municipality',
          link (row) {
            return {
              name: 'branches-view',
              params: { id: row.id }
            }
          }
        },
        {
          label: 'Estado',
          property: 'state'
        },
        {
          label: 'Distribuidor',
          property: 'dealer.name'
        },
        {
          label: 'Tipo',
          property: 'isMainBranch',
          align: 'center'
        }
      ],
      options: {
        selectable: false,
        actions: [
          DefaultActions.edit('branches'),
          DefaultActions.delete('branches')
        ]
      }
    }
  },
  computed: {
    ...mapGetters('branches', {
      items: 'items',
      pager: 'pagination'
    })
  },
  beforeRouteEnter: DefaultGuards.onQuery('branches', { with: 'dealer' }, [
    'name',
    'municipality',
    'state'
  ]),
  beforeRouteUpdate: DefaultGuards.onQuery('branches', { with: 'dealer' }, [
    'name',
    'municipality',
    'state'
  ])
}
</script>

<style lang="scss">
.branches-list-view {
  max-height: 100%;
  overflow: hidden;
  .table {
    tbody {
      tr {
        td {
          &:first-child {
            padding: 0 10px 0 0;
            background-color: transparent;
            width: 50px;
            span {
              background-color: #fff;
              display: block;
              height: 50px;
              vertical-align: middle;
              -webkit-border-radius: 4px;
              -moz-border-radius: 4px;
              border-radius: 4px;
            }
            .type {
              color: $color-ui-primary;
              display: inline-block;
              width: 20px;
              height: 20px;
              border-radius: 2px;
              border: 1px solid $color-ui-primary;
              vertical-align: middle;
              background-color: #fff;
              margin-top: 15px;
              line-height: 20px;
            }
          }
          &:nth-child(2) {
            border-radius: 4px 0 4px 0;
          }
          .branch-type-wrapper {
            text-align: center;
            .branch-type {
              display: inline-block;
              border: 1px solid #cdcdcd;
              color: #666666;
              padding: 5px;
              border-radius: 2px;
              &.main {
                border: 1px solid $color-ui-primary;
                color: $color-ui-primary;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app/branches/branches-list-view.vue